import { render, staticRenderFns } from "./iconVisa.vue?vue&type=template&id=5a07b316&scoped=true"
import script from "./iconVisa.vue?vue&type=script&lang=js"
export * from "./iconVisa.vue?vue&type=script&lang=js"
import style0 from "./iconVisa.vue?vue&type=style&index=0&id=5a07b316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a07b316",
  null
  
)

export default component.exports